import React from 'react';
import { Flex, Toast } from 'antd-mobile';
import { ImgWrap } from 'pubBiz';
import styles from './index.module.less';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ShoppingCartMod from '@/pages/Shop/ShoppingCart/ShoppingCartMod';
import SkuModal from 'pages/Shop/Product/ProductDetail/SkuModal/SkuModalView';

const CartWhite = `https://image.yofogo.com/yundian/assets/icon/common/add_shopping_cart.png`;

const AddCart = ({ imgUrl, className, style, params, callback, type, itemInfo, ...ext }) => {
  return (
    <Flex
      className={cx(styles.image, styles[className])}
      onClick={(e) => {
        e.stopPropagation();
        didAddCart({ params, callback, type, data: itemInfo });
      }}
      style={{ ...style }}>
      <ImgWrap {...ext} src={imgUrl} />
    </Flex>
  );
};

AddCart.defaultProps = {
  imgUrl: CartWhite,
  style: {},
  className: '',
  params: {}
};

AddCart.propTypes = {
  // 购物车图片地址
  imgUrl: PropTypes.string,
  // 内联样式
  style: PropTypes.object,
  // class类 名
  className: PropTypes.string,
  // 商品对象
  params: PropTypes.object
};

const didAddCart = async ({ params, callback, type, data } = {}) => {
  if (type == 6) {
    // 多规格商品逻辑 copy 搜索列表页
    ShoppingCartMod.changeState({ productInfo: data });
    let subItemList = data.subItemList || [];
    if (subItemList.length > 0) {
      ShoppingCartMod.changeState({
        moreSpecificationsData: subItemList,
        showSkuModal: true
      });
      return;
    }
    const r = ShoppingCartMod.getMoreMultiList(params.itemSerial);
    if (r) {
      ShoppingCartMod.changeState({ showSkuModal: true });
    }
    return;
  }
  const result = await ShoppingCartMod.addCart(params);
  if (result) {
    Toast.info('加入购物车成功', 2);
  }
  callback && callback(result);
};

export { AddCart, didAddCart };



// WEBPACK FOOTER //
// ./src/components/AddCart/index.js